import NavMeta from '@/components/NavMeta'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: NavMeta,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}
